import { render, staticRenderFns } from "./LabelBuilding.vue?vue&type=template&id=2b41a898&scoped=true&"
import script from "./LabelBuilding.vue?vue&type=script&lang=js&"
export * from "./LabelBuilding.vue?vue&type=script&lang=js&"
import style0 from "./LabelBuilding.vue?vue&type=style&index=0&id=2b41a898&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b41a898",
  null
  
)

export default component.exports